import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';
import Person from 'services/data/person';
import { currency } from 'utils/format-utils';

function BillableIcon({ billable, amount, currentUser, afterHours = false }) {
  const isLead = Person.isLead(currentUser);
  const total = isLead && !!amount && currency(amount);
  const amountLabel = total && ` - ${total}`;
  let label = 'Non-billable';
  let icon = 'non-billable';

  if (billable && !afterHours) {
    icon = 'billing';
    label = 'Billable';
  }

  if (billable && afterHours) {
    icon = 'moon';
    label = 'Billable (after hours)';
  }

  return (
    <Tooltip title={`${label}${total ? amountLabel : ''}`}>
      <SVG
        src={`svg/${icon}.svg`}
        className={classNames('billable-icon', {
          'bg-success': billable && !afterHours,
          'bg-warning': billable && afterHours
        }
      )}
      />
    </Tooltip>
  );
}

BillableIcon.propTypes = {
  billable: PropTypes.bool,
  amount: PropTypes.number,
  currentUser: PropTypes.object
};

// Exports
export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(BillableIcon);



// WEBPACK FOOTER //
// ./app/components/models/agreement/billable-icon.js